module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n              ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("SHIPPING LINE PAYMENT(INVOICE WISE) CC Import")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [(_vm.ImportDetail.allModuleId && _vm.SBDetail.SlinePayId) ? _c('RemoveSlineInvoiceButton', {
    attrs: {
      "Type": 'All',
      "BTNTitle": '',
      "SlineType": 'Sline',
      "TransportType": 'Import',
      "SlinePayId": _vm.SBDetail.SlinePayId,
      "SlineInvId": '',
      "allModuleId": _vm.ImportDetail.allModuleId
    },
    on: {
      "refresh-data": _vm.refreshData
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ImportDetail.allModuleId ? _vm.ImportDetail.allModuleId : '',
      "jobSeriesBanner": _vm.ImportDetail.ccImportSeries ? _vm.ImportDetail.ccImportSeries : '',
      "bannerClientName": _vm.ImportDetail.clientName ? _vm.ImportDetail.clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(_vm.containerTypeDetailFactoryList.length > 0) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('h5', [_c('b-badge', [_vm._v("Container Details")])], 1), _vm._v(" "), _c('div', [(
    _vm.ContainerTypeSizefactory.ccExecutionContainerId != '' &&
    _vm.showMoreSB == false
  ) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.showMoreSBDet
    }
  }, [_vm._v(_vm._s(_vm.showMoreSB == true ? "Show" : "Hide ") + " Container\n                  Details")]) : _vm._e()], 1), _vm._v(" "), (
    (_vm.getContainerList.length > 0 ||
      _vm.ContainerTypeSizefactory.ccExecutionContainerId != '') &&
    _vm.showMoreSB == false
  ) ? _c('b-card', {
    staticClass: "mt-3",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [(
    _vm.getContainerList.length > 0 ||
    _vm.ContainerTypeSizefactory.ccExecutionContainerId != ''
  ) ? _c('div', {
    staticClass: "gutr"
  }, [(_vm.showMoreSB == false) ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [(
    _vm.ContainerTypeSizefactory.ccExecutionContainerId ==
    ''
  ) ? _c('label', [_vm._v("Container Type/Size")]) : _vm._e(), _vm._v(" "), (
    _vm.ContainerTypeSizefactory.ccExecutionContainerId ==
    ''
  ) ? _c('model-list-select', {
    attrs: {
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "list": _vm.ContainerTypeList,
      "placeholder": "Select  Type/Size"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerTypeId", $$v)
      },
      expression: "ContainerTypeSizefactory.containerTypeId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerType"
    }
  }, [_vm._v("Container Type/Size")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerType),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerType", $$v)
      },
      expression: "ContainerTypeSizefactory.containerType"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.containerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.containerTypeId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No.(eg. AAAA1234567)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "containerNo"
    },
    on: {
      "keyup": _vm.containerNoRegexfun
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerNo", $$v)
      },
      expression: "ContainerTypeSizefactory.containerNo"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.containerNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.containerNo))]) : (_vm.containerNoRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerNoRegexError))]) : _vm._e(), _vm._v(" "), (
    _vm.containerNoRegexError == '' &&
    _vm.ContainerTypeSizefactory.containerNo != '' &&
    _vm.ContainerTypeSizefactory.containerNo !=
    _vm.algoConNo &&
    _vm.showAlgo == true
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Note:System Generated Container No. is :\n                          " + _vm._s(_vm.algoConNo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Net Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "netWeight",
      "name": "netWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.netWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "netWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.netWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Wgt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "grossWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.grossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.grossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.grossWeight))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "weightUnit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.unitList,
      "option-value": "uV",
      "option-text": "uT",
      "placeholder": "Select Unit",
      "name": "weightUnit",
      "id": "weightUnit"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.weightUnit),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "weightUnit", $$v)
      },
      expression: "ContainerTypeSizefactory.weightUnit"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "minute-step": 1,
      "name": "handoverDate",
      "id": "handoverDate"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "handoverDate", $$v)
      },
      expression: "ContainerTypeSizefactory.handoverDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "customSealNo",
      "name": "customSealNo"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.customSealNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "customSealNo", $$v)
      },
      expression: "ContainerTypeSizefactory.customSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Line Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "LineSealNo",
      "name": "LineSealNo"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.LineSealNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "LineSealNo", $$v)
      },
      expression: "ContainerTypeSizefactory.LineSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Tare Wgt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "tareWeight",
      "name": "tareWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.tareWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "tareWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.tareWeight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Measurement (in CBM)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.measurement),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "measurement", $$v)
      },
      expression: "ContainerTypeSizefactory.measurement"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Package Details")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageNameList,
      "id": "clientId",
      "option-value": "packageId",
      "option-text": "packageName",
      "placeholder": "Select  Package Name"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.packageId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "packageId", $$v)
      },
      expression: "ContainerTypeSizefactory.packageId"
    }
  }), _vm._v(" "), (!_vm.ContainerTypeSizefactory.packageId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.packageId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No. of Packages (" + _vm._s(_vm.ContainerTypeSizefactory.packageName) + ")")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0",
      "disabled": _vm.ContainerTypeSizefactory.packageName == '' ?
        true :
        false
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.noOfpkgUnit),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "noOfpkgUnit", $$v)
      },
      expression: "ContainerTypeSizefactory.noOfpkgUnit"
    }
  }), _vm._v(" "), (!_vm.ContainerTypeSizefactory.noOfpkgUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.noOfpkgUnit))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Cargo Stuffing Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "cargoStuffingDate",
      "id": "cargoStuffingDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.cargoStuffingDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "cargoStuffingDate", $$v)
      },
      expression: "ContainerTypeSizefactory.cargoStuffingDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("LEEO (Let Export Permit) Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "leeoDate",
      "id": "leeoDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.leeoDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "leeoDate", $$v)
      },
      expression: "ContainerTypeSizefactory.leeoDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("LEEO (Let Export Permit) No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "leeoNo",
      "id": "leeoNo"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.leeoNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "leeoNo", $$v)
      },
      expression: "ContainerTypeSizefactory.leeoNo"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body mt-2"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ccContainer"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Line Seal No.")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.containerTypeDetailFactoryList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEdit(item.ccExecutionContainerId, index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.containerNo) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEdit(item.ccExecutionContainerId, index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.containerType) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.customSealNo != "" ? item.customSealNo : "--") + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.LineSealNo != "" ? item.LineSealNo : "--") + "\n                      ")])])
  }))])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.SBDetail.SlinePayId != '' && _vm.accounts == false) ||
    (_vm.SBDetail.SlinePayId != '' && _vm.role == 'Admin')
  ) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SBDetail.revisedMail),
      expression: "SBDetail.revisedMail"
    }],
    attrs: {
      "id": 'revcheckbox',
      "name": "checkbox-1",
      "type": "checkbox",
      "value": "1",
      "unchecked-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.SBDetail.revisedMail) ? _vm._i(_vm.SBDetail.revisedMail, "1") > -1 : (_vm.SBDetail.revisedMail)
    },
    on: {
      "click": function($event) {
        _vm.RevisedAss('revcheckbox')
      },
      "change": function($event) {
        var $$a = _vm.SBDetail.revisedMail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.SBDetail.revisedMail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.SBDetail.revisedMail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.SBDetail, "revisedMail", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Send Revised Payment Request")])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("POR"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "name": "POR",
      "id": "POR"
    },
    model: {
      value: (_vm.POR),
      callback: function($$v) {
        _vm.POR = $$v
      },
      expression: "POR"
    }
  }), _vm._v(" "), (_vm.POR_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.POR_err))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("B/L No."), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": (_vm.accounts == true && _vm.role != 'Admin') ||
        _vm.SBDetail.SlinePayId != '' ?
        true :
        false,
      "name": "POR",
      "id": "POR"
    },
    model: {
      value: (_vm.SBDetail.SlineBlNo),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "SlineBlNo", $$v)
      },
      expression: "SBDetail.SlineBlNo"
    }
  }), _vm._v(" "), (_vm.SBDetail.SlineBlNo_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.SBDetail.SlineBlNo_err))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Added By :"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.ImportDetail.username))]), _vm._v("\n                  on\n                  "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.ImportDetail.creationTime))])])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "name": "POR",
      "id": "POR"
    },
    model: {
      value: (_vm.ImportDetail.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.ImportDetail, "shippingLine", $$v)
      },
      expression: "ImportDetail.shippingLine"
    }
  }), _vm._v(" "), (_vm.ImportDetail.shippingLine_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ImportDetail.shippingLine_err))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Estimated SOB Date "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": (_vm.accounts == true && _vm.role != 'Admin') ||
        _vm.SBDetail.SlinePayId != '' ?
        true :
        false,
      "lang": "en",
      "format": _vm.selectDateFormat,
      "name": "sobDate",
      "id": "sobDate",
      "minute-step": 1
    },
    on: {
      "input": _vm.getDueDate
    },
    model: {
      value: (_vm.SBDetail.sobDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "sobDate", $$v)
      },
      expression: "SBDetail.sobDate"
    }
  }), _vm._v(" "), (_vm.SBDetail.sobDate_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.SBDetail.sobDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Payment Due Date"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "disabled": "",
      "lang": "en",
      "name": "sobDate",
      "id": "sobDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.dueDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "dueDate", $$v)
      },
      expression: "SBDetail.dueDate"
    }
  }), _vm._v(" "), (_vm.SBDetail.dueDate_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.SBDetail.dueDate_err))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "my-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('multi-file-uploader', {
    style: ("height: 79px;    background: darkgray;    width: 300px;"),
    attrs: {
      "disabled": (_vm.accounts == true && _vm.role != 'Admin') ||
        _vm.SBDetail.SlinePayId != '' ?
        true :
        false,
      "index": 0,
      "second_index": 0,
      "documentName": 'CC_Import_SlinePay_BLDraft_',
      "otherDocName": 'CC_Import_SlinePay_BLDraft_',
      "folderName": 'BL_DRAFT',
      "accept": '*',
      "assign_no": _vm.ImportDetail.ccImportSeries.replaceAll('/', '_'),
      "multiple": true,
      "state": Boolean(_vm.SBDetail.blDraftUpload),
      "fileAllModuleId": _vm.SBDetail.allModuleId
    },
    model: {
      value: (_vm.SBDetail.blDraftUpload),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "blDraftUpload", $$v)
      },
      expression: "SBDetail.blDraftUpload"
    }
  }), _vm._v(" "), (_vm.SBDetail.blDraftUpload && _vm.SBDetail.blDraftUpload) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.ImportDetail.ccImportSeries.replaceAll('/', '_')) + "/" + (_vm.SBDetail.blDraftUpload)))
      }
    }
  }, [_vm._v("--View")]) : _vm._e(), _vm._v(" "), (_vm.SBDetail.blDraftUpload_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.SBDetail.blDraftUpload_err))]) : _vm._e()], 1), _vm._v(" "), (_vm.FFSeaExportArr.length > 0) ? _c('b-col', {
    staticClass: "ml-5",
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("FF SEA EXPORT Quotation")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "140%",
      "text-align": "center"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Buying Rate")]), _vm._v(" "), _c('th', [_vm._v("Remark")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.FFSeaExportArr), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(item.ffType))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(item.buyingRate + " " + item.currency))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(item.line_wise_remark))])])])
  }))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mb-2",
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), (
    _vm.accounts != true ||
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.addInvArry
    }
  }, [_vm._v("\n              Add Invoice "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lineInvModalArray), function(itm, idx) {
    return _c('b-card', {
      key: idx,
      staticClass: "mt-2"
    }, [(idx != 0) ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "disabled": itm.SlineInvId != '' ? true : false,
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeInvArry(idx)
        }
      }
    }, [_vm._v("\n                  Remove Invoice "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.ImportDetail.allModuleId && _vm.SBDetail.SlinePayId) ? _c('RemoveSlineInvoiceButton', {
      attrs: {
        "BTNTitle": 'Remove Single Invoice',
        "Type": 'Single',
        "SlineType": 'Sline',
        "TransportType": 'Import',
        "SlinePayId": _vm.SBDetail.SlinePayId,
        "SlineInvId": itm.SlineInvId,
        "allModuleId": _vm.ImportDetail.allModuleId
      },
      on: {
        "refresh-data": _vm.refreshData
      }
    }) : _vm._e(), _vm._v(" "), (_vm.SBDetail.revisedMail != 0) ? _c('div', {
      staticClass: "mt-2"
    }, [_c('input', {
      attrs: {
        "disabled": itm['invCurrencyList'][0].invPayStatus == 2 ||
          itm['invCurrencyList'][0].invPayStatus == 1 ?
          true :
          false,
        "id": 'checkbox-' + idx,
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.addRevisedInvoice(idx, 'checkbox-' + idx)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v("Revise Invoice")])]) : _vm._e(), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice Category"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-radio-group', {
      staticClass: "mb-3",
      attrs: {
        "options": _vm.invCategoryList,
        "value-field": "payVal",
        "text-field": "payText",
        "disabled-field": "notEnabled"
      },
      model: {
        value: (itm.invCategory),
        callback: function($$v) {
          _vm.$set(itm, "invCategory", $$v)
        },
        expression: "itm.invCategory"
      }
    }), _vm._v(" "), (itm.invCategory_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invCategory_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice No"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": (_vm.accounts == true && _vm.role != 'Admin') ||
          itm.SlineInvId != '' ?
          true :
          false,
        "name": "shippingBillNo",
        "id": "shippingBillNo"
      },
      model: {
        value: (itm.invNo),
        callback: function($$v) {
          _vm.$set(itm, "invNo", $$v)
        },
        expression: "itm.invNo"
      }
    }), _vm._v(" "), (itm.invNo_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invNo_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('label', [_vm._v("Invoice Type"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
      attrs: {
        "isDisabled": (_vm.accounts == true && _vm.role != 'Admin') ||
          itm.SlineInvId != '' ?
          true :
          false,
        "options": _vm.invoiceTypeList,
        "selected-options": itm.invType,
        "placeholder": "select Type",
        "multiple": true
      },
      on: {
        "select": function($event) {
          _vm.onSelect($event, $event, itm, idx)
        }
      },
      model: {
        value: (itm.invType),
        callback: function($$v) {
          _vm.$set(itm, "invType", $$v)
        },
        expression: "itm.invType"
      }
    }), _vm._v(" "), (itm.invType_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invType_err))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice Date"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "name": "inv_date",
        "id": "inv_date",
        "minute-step": 1
      },
      model: {
        value: (itm.inv_date),
        callback: function($$v) {
          _vm.$set(itm, "inv_date", $$v)
        },
        expression: "itm.inv_date"
      }
    }), _vm._v(" "), (itm.inv_date_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.inv_date_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('label', [_vm._v("Shipping Line Invoice (Drag & Drop)"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('multi-file-uploader', {
      style: ("height: 79px;    background: darkgray;    width: 200px;"),
      attrs: {
        "disabled": (_vm.accounts == true && _vm.role != 'Admin') || itm.enableDisable == true ?
          true :
          false,
        "index": 0,
        "second_index": idx,
        "documentName": 'CC_Import_SlinePay_SlineInv_',
        "otherDocName": 'CC_Import_SlinePay_SlineInv_',
        "folderName": 'Sline_Invoice',
        "accept": '*',
        "assign_no": _vm.ImportDetail.ccImportSeries.replaceAll('/', '_'),
        "multiple": true,
        "state": Boolean(itm.invSlineUpload),
        "fileAllModuleId": _vm.SBDetail.allModuleId
      },
      model: {
        value: (itm.invSlineUpload),
        callback: function($$v) {
          _vm.$set(itm, "invSlineUpload", $$v)
        },
        expression: "itm.invSlineUpload"
      }
    }), _vm._v(" "), (itm.invSlineUpload_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invSlineUpload_err))]) : _vm._e(), _vm._v(" "), (itm.invSlineUpload && itm.invSlineUpload) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.ImportDetail.ccImportSeries.replaceAll('/', '_')) + "/" + (itm.invSlineUpload)))
        }
      }
    }, [_vm._v("--View")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "2"
      }
    }, [_c('b-form-radio-group', {
      staticClass: "mt-4",
      attrs: {
        "options": itm.SlineInvId && itm.dispute_status ? ['Under Dispute', 'Resolved'] : ['Under Dispute'],
        "name": "dispute_status"
      },
      model: {
        value: (itm.dispute_status),
        callback: function($$v) {
          _vm.$set(itm, "dispute_status", $$v)
        },
        expression: "itm.dispute_status"
      }
    })], 1), _vm._v(" "), (itm.dispute_status) ? _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      staticClass: "small text-muted font-weight-bold"
    }, [_vm._v("Sline Dispute Reason "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllRemarkDDList'],
        "option-value": "label",
        "option-text": "label",
        "placeholder": "Search & Select SlineDispute",
        "isDisabled": itm.dispute_status === 'Resolved'
      },
      on: {
        "searchchange": _vm.searchSlineDispute,
        "input": _vm.debounceSearch
      },
      model: {
        value: (itm.sline_dispute),
        callback: function($$v) {
          _vm.$set(itm, "sline_dispute", $$v)
        },
        expression: "itm.sline_dispute"
      }
    }), _vm._v(" "), (itm.sline_dispute_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.sline_dispute_err))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "row mt-2"
    }, [(itm.invCategory == 'Supplementary' || itm.dispute_status === 'Resolved') ? _c('div', {
      staticClass: "col-md-4 row"
    }, [_c('label', {
      staticClass: "col-md-4"
    }, [_vm._v("Bill to Shipper : "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('b-form-radio-group', {
      staticClass: "mb-3",
      attrs: {
        "options": _vm.SCCategoryList,
        "value-field": "SCVal",
        "text-field": "SCText"
      },
      on: {
        "input": function($event) {
          _vm.chnageSCCategoryList(
            itm.scCategory,
            itm.scCategory_err,
            itm.scremark,
            itm.scremark_err,
            _vm.lineInvModalArray,
            idx
          )
        }
      },
      model: {
        value: (itm.scCategory),
        callback: function($$v) {
          _vm.$set(itm, "scCategory", $$v)
        },
        expression: "itm.scCategory"
      }
    }), _vm._v(" "), (
      (itm.scCategory == '' ||
        itm.scCategory == null ||
        itm.scCategory == undefined) &&
      itm.scCategory_err != ''
    ) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.scCategory_err))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (itm.scCategory == 'Yes' || itm.scCategory == 'No') ? _c('div', {
      staticClass: "col-md-4 row"
    }, [_c('label', {
      staticClass: "col-md-3"
    }, [_vm._v("Remark : "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "remark",
        "name": "remark"
      },
      model: {
        value: (itm.scremark),
        callback: function($$v) {
          _vm.$set(itm, "scremark", $$v)
        },
        expression: "itm.scremark"
      }
    }), _vm._v(" "), (
      itm.scremark == '' ||
      itm.scremark == null ||
      itm.scremark == undefined
    ) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n                      Bill to Shipper Remark Field is Required")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (itm.dispute_status === 'Resolved' && itm.scCategory === 'Yes') ? _c('div', {
      staticClass: "col-md-4 row"
    }, [_c('label', {
      staticClass: "col-md-3"
    }, [_vm._v("Amount : "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [_c('b-form-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (itm.resolved_amount),
        callback: function($$v) {
          _vm.$set(itm, "resolved_amount", $$v)
        },
        expression: "itm.resolved_amount"
      }
    }), _vm._v(" "), (itm.resolved_amount_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.resolved_amount_err))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _vm._l((itm['invCurrencyList']), function(currItm, currIdx) {
      return _c('b-card', {
        key: currIdx,
        staticClass: "mt-2"
      }, [_c('div', [(currIdx != 0) ? _c('b-row', [_c('b-col', [_c('div', {
        staticClass: "d-flex align-items-center mt-3"
      }, [_c('b-button', {
        staticClass: "ml-auto",
        attrs: {
          "id": "show-btn",
          "size": "sm",
          "variant": "outline-danger"
        },
        on: {
          "click": function($event) {
            _vm.removeInvCurrency(idx, currIdx)
          }
        }
      }, [_vm._v("\n                          REMOVE AMOUNT\n                          "), _c('i', {
        staticClass: "fa fa-plus",
        attrs: {
          "aria-hidden": "true"
        }
      })])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
        attrs: {
          "cols": "3"
        }
      }, [_c('label', [_vm._v("Invoice Amount"), _c('span', {
        staticClass: "error"
      }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "formatter": _vm.capitalizeAll,
          "disabled": (_vm.accounts == true && _vm.role != 'Admin') ||
            itm.enableDisable == true ?
            true :
            false,
          "name": "shippingBillNo",
          "id": "shippingBillNo",
          "type": "number"
        },
        model: {
          value: (currItm.invAmount),
          callback: function($$v) {
            _vm.$set(currItm, "invAmount", $$v)
          },
          expression: "currItm.invAmount"
        }
      }), _vm._v(" "), (currItm.invAmount_err ? true : false) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(currItm.invAmount_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
        attrs: {
          "cols": "3"
        }
      }, [_c('label', [_vm._v("Currency"), _c('span', {
        staticClass: "error"
      }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "isDisabled": (_vm.accounts == true && _vm.role != 'Admin') ||
            itm.enableDisable == true ?
            true :
            false,
          "list": _vm.currList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Currency"
        },
        model: {
          value: (currItm.invCurrency),
          callback: function($$v) {
            _vm.$set(currItm, "invCurrency", $$v)
          },
          expression: "currItm.invCurrency"
        }
      }), _vm._v(" "), (currItm.invCurrency_err ? true : false) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(currItm.invCurrency_err))]) : _vm._e()], 1), _vm._v(" "), (
        (_vm.SBDetail.SlinePayId != '' && _vm.accounts == true) ||
        (_vm.SBDetail.SlinePayId != '' && _vm.role == 'Admin')
      ) ? _c('b-col', [_c('label', [_vm._v("Payment Mode")]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "isDisabled": _vm.accounts != true && _vm.role != 'Admin' || currItm.invPayStatus != '' ? true : false,
          "list": _vm.payList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Mode"
        },
        model: {
          value: (currItm.invPayMode),
          callback: function($$v) {
            _vm.$set(currItm, "invPayMode", $$v)
          },
          expression: "currItm.invPayMode"
        }
      }), _vm._v(" "), (currItm.invPayMode_err ? true : false) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(currItm.invPayMode_err))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
        (_vm.SBDetail.SlinePayId != '' && _vm.accounts == true) ||
        (_vm.SBDetail.SlinePayId != '' && _vm.role == 'Admin')
      ) ? _c('b-col', [_c('label', [_vm._v("Payment Ref")]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "disabled": ((_vm.accounts != true) || (currItm.invPayStatus != '' && _vm.$sessionsStorage.get('cust_username') != 'laxmi@pridel.com' && _vm.role != 'Admin')) ? true : false,
          "formatter": _vm.capitalizeAll,
          "name": "shippingBillNo",
          "id": "shippingBillNo"
        },
        on: {
          "input": function($event) {
            _vm.cahngeDisableButton(currItm.invPayRef)
          }
        },
        model: {
          value: (currItm.invPayRef),
          callback: function($$v) {
            _vm.$set(currItm, "invPayRef", $$v)
          },
          expression: "currItm.invPayRef"
        }
      }), _vm._v(" "), (currItm.invPayRef_err ? true : false) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(currItm.invPayRef_err))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (
        (_vm.SBDetail.SlinePayId != '' && _vm.accounts == true) ||
        (_vm.SBDetail.SlinePayId != '' && _vm.role == 'Admin')
      ) ? _c('b-row', [_c('b-col', {
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Amount")]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "disabled": _vm.accounts != true && _vm.role != 'Admin' || currItm.invPayStatus != '' ? true : false,
          "formatter": _vm.capitalizeAll,
          "name": "shippingBillNo",
          "id": "shippingBillNo"
        },
        model: {
          value: (currItm.invPaidAmount),
          callback: function($$v) {
            _vm.$set(currItm, "invPaidAmount", $$v)
          },
          expression: "currItm.invPaidAmount"
        }
      }), _vm._v(" "), (currItm.invPaidAmount_err ? true : false) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(currItm.invPaidAmount_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
        staticClass: "mt-4",
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('date-picker', {
        attrs: {
          "disabled": ((_vm.accounts != true) || (currItm.invPayStatus != '' && _vm.$sessionsStorage.get('cust_username') != 'laxmi@pridel.com' && _vm.role != 'Admin')) ? true : false,
          "format": _vm.selectDateFormat,
          "lang": "en",
          "name": "shippingBillNo",
          "id": "shippingBillNo",
          "minute-step": 1
        },
        on: {
          "input": function($event) {
            _vm.cahngeDisableButton(currItm.invPayDate)
          }
        },
        model: {
          value: (currItm.invPayDate),
          callback: function($$v) {
            _vm.$set(currItm, "invPayDate", $$v)
          },
          expression: "currItm.invPayDate"
        }
      }), _vm._v(" "), (currItm.invPayDate_err ? true : false) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(currItm.invPayDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Status")]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "isDisabled": _vm.accounts != true && _vm.role != 'Admin' || currItm.invPayStatus != '' ? true : false,
          "list": _vm.statusList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Status"
        },
        model: {
          value: (currItm.invPayStatus),
          callback: function($$v) {
            _vm.$set(currItm, "invPayStatus", $$v)
          },
          expression: "currItm.invPayStatus"
        }
      }), _vm._v(" "), (currItm.invPayStatus_err ? true : false) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(currItm.invPayStatus_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col')], 1) : _vm._e()], 1)], 1)])
    })], 2)
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_vm._v("\n                \"\n                "), (_vm.lineInvModalArray.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.addSBDetail_button == true || ((_vm.SBDetail.paymentDone == '1' || _vm.disableSaveSubmit == true) && !_vm.isDisputeResolved) ?
        true :
        false,
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addSBDetail
    }
  }, [_vm._v("Save & Submit\n                ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1)], 2)])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "my-modal",
    attrs: {
      "id": "supModal",
      "size": "xl",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('suplimentry-inv', {
    key: _vm.componentKey,
    attrs: {
      "suplimentaryInvDataSingleArry": _vm.getSuplimentaryInvData
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e974fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/ccSLinePaymentImportN.vue
// module id = 2709
// module chunks = 0